import { Station } from '@mi-front/core';
import { AuditMatchCategoryNavigator } from '../../components/AuditMatchCategoryNavigator';
import { AdOverlayView } from './components/ad-overlay/AdOverlayView';
import { AdsMatchesView } from './components/ads/AdsMatchesView';
import { LiveMentionsMatchesView } from './components/live-mentions/LiveMentionsMatchesView';
import { MatchCategory } from './types';

export function MatchesRootView({ station }: { station: Station }) {
  return (
    <AuditMatchCategoryNavigator>
      {(category) => {
        if (category === MatchCategory.ADS) {
          return <AdsMatchesView station={station} />;
        }

        if (category === MatchCategory.LIVE_MENTIONS) {
          return <LiveMentionsMatchesView station={station} />;
        }

        if (category === MatchCategory.AD_OVERLAY) {
          return <AdOverlayView station={station} />;
        }
      }}
    </AuditMatchCategoryNavigator>
  );
}
